export default __webpack_public_path__ + "static/book-flash-5a9c81d97f522d2219c998fe93baf6da.png";